// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"302550a9","239":"4f7dcff9","455":"c5ca416d"}[chunkId] + ".chunk.js";
};